import { Reducer } from 'react';
import { useAccordion } from '../../_lib/components/Accordion';
import { ToggleAction } from '../../_lib/components/Accordion/useAccordion';
import { ID } from '../../types/api/ID';

type CloseAllAction = {
  type: 'closeAll';
};
type OpenAction = {
  type: 'open';
  ids: string[];
};

const reducer: Reducer<string[], CloseAllAction | OpenAction | ToggleAction> = (state, action) => {
  switch (action.type) {
    case 'toggle':
      return state.includes(action.id) ? state.filter(id => id !== action.id) : [...state, action.id];
    case 'closeAll':
      return [];
    case 'open':
      return action.ids;
    default:
      return state;
  }
};

export function useFaqAccordion<TItems extends ID>(data: TItems[]) {
  const { dispatch, ...props } = useAccordion(data, { reducer });
  const closeAll = () => dispatch({ type: 'closeAll' });
  const openAll = () => dispatch({ type: 'open', ids: data.map(({ id }) => id) });
  return { ...props, closeAll, openAll };
}
